import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'

function FilterHeader({ isVisible, filters, handleReset, className }) {
  const [filterString, setFilterString] = useState('')

  useEffect(() => {
    const stringParts = []

    for (const [key, value] of Object.entries(filters)) {
      if (key === 'housetrained' && value !== '') {
        stringParts.push('Housetrained')
        continue
      }

      if (value !== '') {
        stringParts.push(value)
      }
    }

    setFilterString(stringParts.join(', '))
  }, [filters])

  if (!isVisible) {
    return null
  }

  return (
    <div className={className}>
      <div>
        <strong>Showing:</strong> {filterString}
      </div>

      <button type="button" className="font-bold hover:underline text-brand-red" onClick={handleReset}>
        Try Another Search
      </button>
    </div>
  )
}

FilterHeader.propTypes = {
  isVisible: PropTypes.bool,
  isLoading: PropTypes.bool,
  filters: PropTypes.object,
  handleReset: PropTypes.func,
  className: PropTypes.string,
}

export default FilterHeader
